



















import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { MigrationImport } from "@/entities";
import { AppConstants as _app } from "@/shared/app.constants";
import FormattedNumber from "@/components/common/Inputs/FormattedNumber.vue";
import TableComponent from "@/components/App/Modules/GMS/Grants/FinancialReport/Components/Components/ConsolidationTable.vue";

const namespace: string = "migration";
@Component({
  components: {
    TableComponent,
    FormattedNumber,
  },
})
export default class ConsolidationComponent extends Vue {
  @State(namespace) migration!: MigrationImport;

  @Prop() schema: any;
  @Prop() model: any;
  @Prop() validations: any;
  @Prop() formOptions: any;

  mounted() {}

  get dataModel() {
    if (!this.model.consolidation) {
      this.model.consolidation = {};
    }
    return this.model.consolidation;
  }

  get header() {
    if (
      this.schema &&
      this.schema.properties &&
      this.schema.properties.detailedListingHeaders
    ) {
      return this.schema.properties.detailedListingHeaders.items;
    }
  }

  get budgetCategories() {
    return this.migration.BudgetCategories;
  }

  get budget() {
    let obj: any = {};
    if (
      this.migration.ImportData &&
      this.migration.ImportData.applicationBudget
    ) {
      obj = this.migration.ImportData.applicationBudget;
    }
    return obj;
  }
}
